import { Icon, Icons } from 'components/Icon';
import React from 'react';

type Props = {
  name: string;
  count: number;
  icon: string;
};

export default function AdminStatCard({ name, count, icon }: Props) {
  return (
    <div>
      <div className="flex w-[22rem] shrink-0 items-center justify-between rounded-md bg-white p-7">
        <div className="flex flex-col">
          <h5 className="mb-2 text-sm font-medium text-[#7A7C87]">{name}</h5>
          <h5 className="mb-2 text-5xl font-medium text-black">{count}</h5>
        </div>
        <Icon name={icon as Icons} />
      </div>
    </div>
  );
}
